import { render, staticRenderFns } from "./FaceApproveSearchHistoryDetails.vue?vue&type=template&id=7db7a2b4&scoped=true"
import script from "./FaceApproveSearchHistoryDetails.vue?vue&type=script&lang=js"
export * from "./FaceApproveSearchHistoryDetails.vue?vue&type=script&lang=js"
import style0 from "./FaceApproveSearchHistoryDetails.vue?vue&type=style&index=0&id=7db7a2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db7a2b4",
  null
  
)

export default component.exports